"use client";

import { fetchGetCompanyBusinessHours, fetchGetCompanySubsidiaries } from "@/services/api";
import { useState, useEffect } from "react";

export default function Footer({ company }) {

    const [businessHours, setBusinessHours] = useState([]);

    useEffect(() => {
        const fetchBusinessHours = async () => {
            const hours = [];
            try {
                const res = await fetchGetCompanyBusinessHours();
                if (res.monday && res.tuesday && res.wednesday && res.thursday && res.friday) {
                    const sameWeekdayHours =
                        res.mondayOpeningTime === res.tuesdayOpeningTime &&
                        res.mondayOpeningTime === res.wednesdayOpeningTime &&
                        res.mondayOpeningTime === res.thursdayOpeningTime &&
                        res.mondayOpeningTime === res.fridayOpeningTime &&
                        res.mondayClosingTime === res.tuesdayClosingTime &&
                        res.mondayClosingTime === res.wednesdayClosingTime &&
                        res.mondayClosingTime === res.thursdayClosingTime &&
                        res.mondayClosingTime === res.fridayClosingTime;

                    if (sameWeekdayHours) {
                        hours.push({ name: 'Segunda à Sexta', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                    } else {
                        if (res.monday) {
                            hours.push({ name: 'Segunda-feira', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                        }
                        if (res.tuesday) {
                            hours.push({ name: 'Terça-feira', openingTime: res.tuesdayOpeningTime.slice(0, 5), closingTime: res.tuesdayClosingTime.slice(0, 5) });
                        }
                        if (res.wednesday) {
                            hours.push({ name: 'Quarta-feira', openingTime: res.wednesdayOpeningTime.slice(0, 5), closingTime: res.wednesdayClosingTime.slice(0, 5) });
                        }
                        if (res.thursday) {
                            hours.push({ name: 'Quinta-feira', openingTime: res.thursdayOpeningTime.slice(0, 5), closingTime: res.thursdayClosingTime.slice(0, 5) });
                        }
                        if (res.friday) {
                            hours.push({ name: 'Sexta-feira', openingTime: res.fridayOpeningTime.slice(0, 5), closingTime: res.fridayClosingTime.slice(0, 5) });
                        }
                    }
                }
                if (res.saturday) {
                    hours.push({ name: 'Sábado', openingTime: res.saturdayOpeningTime.slice(0, 5), closingTime: res.saturdayClosingTime.slice(0, 5) });
                }
                if (res.sunday) {
                    hours.push({ name: 'Domingo', openingTime: res.sundayOpeningTime.slice(0, 5), closingTime: res.sundayClosingTime.slice(0, 5) });
                }
                if (res.holiday) {
                    hours.push({ name: 'Feriado', openingTime: res.holidayOpeningTime.slice(0, 5), closingTime: res.holidayClosingTime.slice(0, 5) });
                }
                setBusinessHours(hours);
            } catch (error) {
                console.error('Erro ao buscar os horários de funcionamento:', error);
            }
        };

        fetchBusinessHours();
    }, []);

    const cnpjMask = (number) => {
        number.replace(/\D/g, '');
        return number.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1. $2. $3/$4-$5")
    }

    const [subsidiaries, setSubsidiaries] = useState([])
    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet
                }))
                setSubsidiaries(subs)
            })
    }, [])

    const message = `Olá, gostaria de informações sobre a ${company.nickName}`;

    return (
        <footer className="site-footer theme-pl-30 theme-pr-30">
            <div className="auto-container content-footer">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 theme-mb-30 d-f">
                        <h3 className="footer-widget-title">{subsidiaries.length > 0 ? "Localização - Matriz" : "Localização"}</h3>
                        <div className="clearfix w-100 d-block theme-pb-20"></div>
                        <ul className="list-unstyled footer-widget-contact theme-mt-20">
                            <li>
                                <i className="mdi mdi-map-marker"></i>
                                {company.address}<br />{`${company.city} - ${company.federativeUnit}`}
                            </li>
                        </ul>
                        <div className="clearfix w-100 d-block theme-pb-20"></div>
                        <div className="footer__social">
                            <ul className="social-icons social-icons-gray color-hover">
                                <li className="social-google-maps">
                                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(company.address + ', ' + company.city + ' - ' + company.federativeUnit)}`} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                        <i className="mdi mdi-google-maps"></i>
                                    </a>
                                </li>
                                <li className="social-waze">
                                    <a href={`https://waze.com/ul?q=${encodeURIComponent(`${company.address}, ${company.city}`)}&navigate=yes`} rel="nofollow" target="_blank" title="Como chegar pelo Waze">
                                        <i className="mdi mdi-waze"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        {subsidiaries.length > 0 ?
                            subsidiaries.map((item, index) => (
                                <div key={index} className="mt-2">
                                    <h3 className="footer-widget-title">Localização - Filial</h3>
                                    <div className="clearfix w-100 d-block theme-pb-20"></div>
                                    <ul className="list-unstyled footer-widget-contact theme-mt-20">
                                        <li>
                                            <i className="mdi mdi-map-marker"></i>
                                            {item.address}<br />{`${item.city} - ${item.federativeUnit}`}
                                        </li>
                                    </ul>
                                    <div className="clearfix w-100 d-block theme-pb-20"></div>
                                    <div className="footer__social">
                                        <ul className="social-icons social-icons-gray color-hover">
                                            <li className="social-google-maps">
                                                <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(item.address + ', ' + item.city + ' - ' + item.federativeUnit)}`} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                                    <i className="mdi mdi-google-maps"></i>
                                                </a>
                                            </li>
                                            <li className="social-waze">
                                                <a href={`https://waze.com/ul?q=${encodeURIComponent(`${item.address}, ${item.city}`)}&navigate=yes`} rel="nofollow" target="_blank" title="Como chegar pelo Waze">
                                                    <i className="mdi mdi-waze"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            ))
                            : null}
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 theme-mb-30">
                        <h3 className="footer-widget-title">{subsidiaries.length > 0 ? "Contato - Matriz" : "Contato"}</h3>
                        <div className="clearfix w-100 d-block theme-mb-20"></div>
                        <ul className="list-unstyled footer-widget-contact ">
                            <li>
                                <i className="mdi mdi-phone"></i>
                                <a className="list-inline-item" href={`tel:+55${company.phone}`} rel="nofollow" target="_blank" title={`Telefone - ${company.nickName}`}>
                                    {
                                        company.phone?.length === 10
                                            ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 6)}-${company.phone.substring(6, 10)}`
                                            : company.phone?.length === 11
                                                ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 7)}-${company.phone.substring(7, 11)}`
                                                : company.phone
                                    }
                                </a>
                            </li>
                            <li>
                                <i className="mdi mdi-whatsapp"></i>
                                <a className="list-inline-item" href={`https://api.whatsapp.com/send?phone=55${company.whatsapp}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : message}`} rel="nofollow" target="_blank" title={company.nickName}>
                                    {
                                        company.whatsapp?.length === 10
                                            ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 6)}-${company.whatsapp.substring(6, 10)}`
                                            : company.whatsapp?.length === 11
                                                ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 7)}-${company.whatsapp.substring(7, 11)}`
                                                : company.whatsapp
                                    }
                                </a>
                            </li>
                            <li>
                                <i className="mdi mdi-email"></i>
                                <a href={`mailto:${company.email}`} title={company.nickName}>
                                    {company.email}
                                </a>
                            </li>

                            {businessHours.map((hour, index) => (
                                <li key={index}><i className="mdi mdi-clock"></i>{hour.name} : {hour.openingTime} - {hour.closingTime}</li>
                            ))}

                        </ul>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 theme-mb-30">
                        <h3 className="footer-widget-title">Siga-nos</h3>
                        <div className="footer-widget">
                            <div className="footer__social">
                                <ul className="social-icons color-hover social-icons-large">
                                    {
                                        company.facebook
                                            ? <li className="social-facebook">
                                                <a href={company.facebook} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="mdi mdi-facebook"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                    {
                                        company.instagram
                                            ? <li className="social-instagram">
                                                <a href={company.instagram} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="mdi mdi-instagram"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                    {
                                        company.youtube
                                            ? <li className="social-youtube">
                                                <a href={company.youtube} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="mdi mdi-youtube"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                    {
                                        company.tiktok
                                            ? <li className="social-tiktok">
                                                <a href={company.tiktok} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="fa-brands fa-tiktok"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                </ul>
                            </div>
                        </div>
                        <h3 className="footer-widget-title mt-2">CNPJ</h3>
                        <div className="footer_about_widget">
                            <p>{cnpjMask(company.cnpj)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 theme-mb-30 pagemapa">
                        <iframe src={`https://maps.google.com/maps?q=${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`} width="100%" height="250" style={{ border: '0' }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        {subsidiaries.length > 0 ?
                            subsidiaries.map((item, index) => (

                                <iframe key={index} src={`https://maps.google.com/maps?q=${item.address} - ${item.city} - ${item.federativeUnit} - ${item.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`} width="100%" height="250" style={{ border: '0' }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

                            ))
                            : null}
                    </div>
                </div>
            </div>
            <div className="auto-container copyright content-footer">
                <div className="row align-items-center">
                    <div className="col-md-12 text-center wow fadeIn" data-wow-delay="400ms">
                        <p>Copyright © Todos os direitos reservados -
                            <a href="https://bndv.com.br" target="_blank" title="BNDV - Banco Nacional de Veículo - Sistema para revenda de veículos"> Desenvolvido por BNDV </a> -
                            <a href="/politica-de-privacidade" title="Conheça nossa política de Privacidade"> Política de Privacidade</a>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}